import {createType, createAction} from 'store/utils';

const prefix = 'UI';

export const OPEN_SETTINGS = createType(prefix, 'OPEN_SETTINGS');
export const openSettings = (): Action => createAction(OPEN_SETTINGS);

export const CLOSE_SETTINGS = createType(prefix, 'CLOSE_SETTINGS');
export const closeSettings = (): Action => createAction(CLOSE_SETTINGS);

export const TOGGLE_HISTORY = createType(prefix, 'TOGGLE_HISTORY');
export const toggleHistory = (): Action => createAction(TOGGLE_HISTORY);

export const SHOW_KEYBOARD = createType(prefix, 'SHOW_KEYBOARD');
export const showKeyboard = (): Action => createAction(SHOW_KEYBOARD);

export const HIDE_KEYBOARD = createType(prefix, 'HIDE_KEYBOARD');
export const hideKeyboard = (): Action => createAction(HIDE_KEYBOARD);

export const TOGGLE_UNDO = createType(prefix, 'TOGGLE_UNDO');
export const toggleUndo = (): Action => createAction(TOGGLE_UNDO);
